<div class="modal-header">
  <h5 class="modal-title" i18n="@@TechnicalChargingStationsUnlockConnectorTooltip">Konnektor entriegeln</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <p class="text-muted mb-3" *ngIf="station">{{ station.name }}</p>
  <p class="mb-3" i18n="@@TechnicalChargingStationsUnlockModalIntro">Wählen Sie den Konnektor, den Sie entriegeln möchten:</p>
  <div class="d-flex flex-wrap gap-2">
    <button type="button" class="btn btn-outline-primary"
      *ngFor="let cp of station?.chargingPoints"
      [disabled]="loadingConnectorId !== null"
      (click)="unlock(cp.connectorId)">
      <span *ngIf="loadingConnectorId === cp.connectorId" class="spinner-border spinner-border-sm me-1" role="status"></span>
      Konnektor {{ cp.connectorId }}
    </button>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()" i18n="@@CancelButton">Abbrechen</button>
</div>
